export function initHeroesListMore() {
    var wrap = document.querySelector('[data-museum-heroes-more-wrap]');
    if (!wrap) {
        return;
    }

    var list = wrap.querySelector('[data-museum-heroes-list]');
    var btn = wrap.querySelector('[data-museum-heroes-more]');

    if (!list || !btn) {
        return;
    }

    btn.addEventListener('click', function () {
        list.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
        btn.hidden = true;
    });
}
